<ngx-loading-bar [includeSpinner]="false" />
<app-toasts />
<router-outlet />
